import { Component, OnInit } from '@angular/core';

import { UserService } from 'src/app/services/user.service';

import { User } from 'src/app/interfaces/user';
import { DeviceDetectorService } from 'ngx-device-detector';
import { StorageService } from 'src/app/services/storage.service';
import { Router } from '@angular/router';
import { Exercise } from 'src/app/interfaces/exercise';

import { Modal } from 'bootstrap';
import { StateService } from 'src/app/services/state.service';
import { Plan } from 'src/app/interfaces/plan';

import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';

import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  plans: Plan[] = [];
  users: User[] = [];
  isMobile: boolean = false;
  selectedUser: User | undefined;
  editingForm: boolean = false;
  selectedExercise: Exercise | undefined;
  searchObject: any = {};
  searchString: string = '';
  searchSelected: 'DNI' | 'nombre' = 'nombre';
  searchBar: FormControl = new FormControl('');
  planType: FormControl = new FormControl(null);
  planStatus: FormControl = new FormControl(null);

  isTablet: boolean = false;

  planStatusDict: any = {
    REQUIRED_FORM: 'Pendiente: ',
    REQUIRED_TRAINER_AND_NUTRISIONIST: 'Falta entrenador y nutricionista',
    REQUIRED_TRAINER: 'Falta entrenador',
    REQUIRED_NUTRISIONIST: 'Falta nutricionista',
    STARTED: 'Empezado',
    PRE_STARTED: 'Empieza el próximo Lunes',
    FINISHED: 'Finalizado',
  };

  formTypeDict: any = {
    CHECK_METRICS: 'Chequeo',
    FIRST_CHECK_METRICS: 'Primer chequeo',
    AUTOMATIC_ROUTINE_GROUP: 'Rutina automatica',
    INTRODUCTION: 'Formulario introducción',
    INTRODUCTION_GYM: 'Formulario introducción GYM',
  };

  constructor(
    private userService: UserService,
    private deviceService: DeviceDetectorService,
    private storageService: StorageService,
    private router: Router,
    private stateService: StateService
  ) {}

  ngOnInit(): void {
    dayjs.extend(utc);
    this.isMobile = this.deviceService.isMobile();
    this.isTablet = this.storageService.get('isTablet');

    this.userService.getAllUsers().subscribe({
      next: (response: any) => {
        this.parseUsers(response.users);
        this.getPlans();
      },
    });

    if (!this.storageService.get('staffUser')) {
      this.manageNotLoggedInUser();
    } else if (this.isTablet) this.router.navigate(['/home-tablet']);
  }

  manageNotLoggedInUser() {
    this.storageService.get('isTablet')
      ? this.router.navigate(['login-tablet'])
      : this.router.navigate(['login']);
  }

  getPlans() {
    this.userService.getPlans().subscribe({
      next: (plans: Plan[]) => {
        this.plans = plans;
      },
    });
  }

  openConfigModal(user: User) {
    this.selectedUser = user;
    this.storageService.set('selectedUser', JSON.stringify(user));
    const optionsModal = new Modal('#userConfigModal');
    this.stateService.openModal = optionsModal;
    this.stateService.selectedUser = user;

    optionsModal.show();
  }

  openExerciseListModal() {
    const exerciseListModal = new Modal('#exerciseListModal');
    this.stateService.openModal = exerciseListModal;

    exerciseListModal.show();
  }

  openTutorialsModal() {
    const tutorialsModal = new Modal('#tutorialsModal');
    this.stateService.openModal = tutorialsModal;

    tutorialsModal.show();
  }

  openFoodsModal() {
    const foodListModal = new Modal('#foodListModal');
    this.stateService.openModal = foodListModal;

    foodListModal.show();
  }

  parseUsers(users: User[]) {
    this.users = users;

    if (users) {
      this.users.forEach((u: User) => {
        const birthdate = dayjs(u.birthdate).utc();

        u.parsedBirthdate = `${birthdate.get('date')}/${
          birthdate.get('month') + 1
        }/${birthdate.get('year')}`;

        if (u.planHistory) {
          u.planHistory.forEach((p: Plan) => {
            // Parcing all the status to spanish
            if (p.status != 'FINISHED') {
              if (
                p.status == 'REQUIRED_TRAINER_OR_NUTRISIONIST' &&
                p.routineIsPending &&
                p.dietIsPending
              ) {
                p.status = 'REQUIRED_TRAINER_AND_NUTRISIONIST';
              } else if (
                p.status == 'REQUIRED_TRAINER_OR_NUTRISIONIST' &&
                p.dietIsPending &&
                !p.routineIsPending
              ) {
                p.status = 'REQUIRED_NUTRISIONIST';
              } else if (
                p.status == 'REQUIRED_TRAINER_OR_NUTRISIONIST' &&
                p.routineIsPending &&
                !p.dietIsPending
              ) {
                p.status = 'REQUIRED_TRAINER';
              }

              p.status = this.planStatusDict[p.status!];

              if (u.pendingForms) {
                u.pendingForms.forEach((form: any, index: number) => {
                  index > 0
                    ? (p.status += ', ' + this.formTypeDict[form.type])
                    : (p.status += this.formTypeDict[form.type]);
                });
              }

              u.activePlan = p;
            }
          });
        } else {
          u.newUser = true;
        }

        // Parcing all the status expirations to days left
        const today = dayjs().utc();

        if (u.activeRoutineGroup) {
          const routineFinish = dayjs(u.activeRoutineGroup?.finishedAt.Time)
            .utc()
            .add(1, 'day');
          u.activeRoutineGroupDaysToExpire = routineFinish.diff(today, 'days');

          const diffDays = routineFinish.diff(today, 'days');

          u.activeRoutineGroupDaysToExpire = diffDays;

          const diffWeeks = Math.floor(diffDays / 7);
          const diffReminderDays = diffDays % 7;

          u.activeRoutineGroupWeeksToExpire =
            diffReminderDays > 0
              ? `${diffWeeks}s ${diffReminderDays}d`
              : `${diffWeeks}s`;
        }

        if (u.activeDiet) {
          const activeDiet = dayjs(u.activeDiet.finishedAt).utc().add(1, 'day');

          const diffDays = activeDiet.diff(today, 'days');

          u.activeDietDaysToExpire = diffDays;

          const diffWeeks = Math.floor(diffDays / 7);
          const diffReminderDays = diffDays % 7;

          u.activeDietWeeksToExpire =
            diffReminderDays > 0
              ? `${diffWeeks}s ${diffReminderDays}d`
              : `${diffWeeks}s`;
        }

        if (u.activePlan) {
          const planFinish = dayjs(u.activePlan?.finishAt.Time)
            .utc()
            .add(1, 'day');

          const diffDays = planFinish.diff(today, 'days');

          u.activePlanDaysToExpire = diffDays;

          const diffWeeks = Math.floor(diffDays / 7);
          const diffReminderDays = diffDays % 7;

          u.activePlanWeeksToExpire =
            diffReminderDays > 0
              ? `${diffWeeks}s ${diffReminderDays}d`
              : `${diffWeeks}s`;
        }

        const date = new Date(u.createdAt);
        let newDate = `${date.getDate()}/${
          date.getMonth() + 1
        }/${date.getFullYear()}`;
        u.createdAt = newDate;
      });

      this.sortUsers();
    }
  }

  sortUsers() {
    this.users.forEach((u: User) => {
      u.numberToSort = this.findSmallest(
        u.activeDietDaysToExpire,
        u.activePlanDaysToExpire,
        u.activeRoutineGroupDaysToExpire
      );
    });

    this.users.sort((a: User, b: User) => {
      let orderElement: number = 0;

      if (!a.planHistory && b.planHistory) {
        orderElement = -1;
      } else if (a.planHistory && !b.planHistory) {
        orderElement = 1;
      } else {
        if (
          (a.activePlan?.routineIsPending || a.activePlan?.dietIsPending) &&
          !(b.activePlan?.routineIsPending || b.activePlan?.dietIsPending)
        ) {
          orderElement = -1;
        } else if (
          !(a.activePlan?.routineIsPending || a.activePlan?.dietIsPending) &&
          (b.activePlan?.routineIsPending || b.activePlan?.dietIsPending)
        ) {
          orderElement = 1;
        } else {
          if (
            typeof a.numberToSort === 'undefined' &&
            typeof b.numberToSort === 'undefined'
          ) {
            orderElement = 0;
          } else if (
            typeof a.numberToSort !== 'undefined' &&
            typeof b.numberToSort === 'undefined'
          ) {
            orderElement = -1;
          } else if (
            typeof a.numberToSort === 'undefined' &&
            typeof b.numberToSort !== 'undefined'
          ) {
            orderElement = 1;
          } else if (a.numberToSort! <= b.numberToSort!) {
            orderElement = -1;
          } else if (a.numberToSort! > b.numberToSort!) {
            orderElement = 1;
          }
        }
      }

      return orderElement;
    });
  }

  findSmallest(a?: number, b?: number, c?: number): number | undefined {
    let smallest: number | undefined = undefined;

    if (
      typeof a !== 'undefined' &&
      (typeof smallest === 'undefined' || a < smallest)
    ) {
      smallest = a;
    }

    if (
      typeof b !== 'undefined' &&
      (typeof smallest === 'undefined' || b < smallest)
    ) {
      smallest = b;
    }

    if (
      typeof c !== 'undefined' &&
      (typeof smallest === 'undefined' || c < smallest)
    ) {
      smallest = c;
    }

    return smallest;
  }

  manageSelectFilter(type: 'plan' | 'statusPlanFilter' | 'clean', event: any) {
    if (event.target.value === 'null') {
      delete this.searchObject[type];
    } else {
      this.searchObject[type] = event.target.value;
    }

    this.filterUsers();
  }

  manageInputFilter(): void {
    if (this.searchBar.value == '') {
      delete this.searchObject['dni'];
      delete this.searchObject['name'];

      this.updateSearchString();
    } else if (Number.isNaN(parseInt(this.searchBar.value))) {
      delete this.searchObject['dni'];
      this.searchObject['name'] = this.searchBar.value;

      this.searchSelected = 'nombre';
    } else {
      delete this.searchObject['name'];

      this.searchSelected = 'DNI';
      this.searchObject['dni'] = this.searchBar.value;
    }

    this.filterUsers();
  }

  filterUsers() {
    this.updateSearchString();

    this.userService.filterUsers(this.searchString).subscribe({
      next: (response: any) => {
        this.parseUsers(response.users);
      },
    });
  }

  updateSearchString(): void {
    this.searchString = '';
    Object.entries(this.searchObject).forEach(([key, value]) => {
      if (this.searchString.length < 1) {
        this.searchString += `${key}=${value}`;
      } else {
        this.searchString += `&${key}=${value}`;
      }
    });
  }

  selectUser(user: User, ev: Event | null = null, type: any = 'default') {
    if (ev) {
      ev.stopPropagation();
    }

    this.selectedUser = user;
    this.storageService.set('selectedUser', JSON.stringify(user));
  }

  logout() {
    this.storageService.get('isTablet')
      ? this.router.navigate(['/login-tablet'])
      : this.router.navigate(['/login']);

    this.storageService.clearAllData();
  }

  onEditChange(ev: Array<any>) {
    this.editingForm = ev[0];
    this.selectedExercise = ev[1];
  }

  undefinedFinishPlan(user: User): boolean {
    if (!user.activePlanWeeksToExpire || !user.activePlan?.finishAt.Valid) {
      return true;
    } else {
      return false;
    }
  }

  infinitePlan(user: User) {
    if (
      user.activePlanWeeksToExpire &&
      parseInt(user.activePlanWeeksToExpire) > 1000
    ) {
      return true;
    } else {
      return false;
    }
  }
}
